import { Expose } from 'class-transformer';

export class CompanyStationsDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'company_id' })
  companyId: number;
  @Expose({ name: 'credits_per_station' })
  creditsPerStation: number;
  @Expose({ name: 'stations_amount' })
  stationsAmount: number;
  @Expose({ name: 'users_per_station' })
  usersPerStation: number;
}
